module.exports = __webpack_public_path__ + "e61b94bccbdbf68fa03d0e64d936d581.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/dow_image_mobile.jpg
// module id = 297
// module chunks = 0